import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from 'react-router-dom';
import './css/style.scss';
import './charts/ChartjsConfig';

import Dashboard from './pages/dashboard/index.js';
import SignIn from 'pages/auth/SignIn';
import { PrivateRoute } from 'components/PrivateRoute';
import ErrorPage404 from 'components/ErrorPage404';
import 'translations/i18n'
function App() {
  return (
    <Router>
      <Switch>
        <Route path="/login" component={SignIn} />
        <PrivateRoute exact path="/*" permission="dashboard:view" component={Dashboard} />
        <Redirect from='/logout' to='/login' />
        <Route component={ErrorPage404} />

      </Switch>
    </Router>
  );
}

export default App;

